<nb-card style="min-width: 480px; max-width: 640px">
  <nb-card-header>
    <strong>{{ dialogTitle() }}</strong>
  </nb-card-header>
  <nb-card-body>
    <div class="warning-banner">
      <nb-icon icon="alert-triangle-outline"></nb-icon>
      <strong>{{ 'DEV_CLIENTS.SECRET_DIALOG.WARNING' | translate }}</strong>
    </div>

    <div class="secret-row" style="margin-top: 20px">
      <label class="form-label">{{ 'DEV_CLIENTS.SECRET_DIALOG.CLIENT_ID' | translate }}</label>
      <div class="secret-box-wrapper">
        <code class="secret-box">{{ clientId }}</code>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary copy-btn"
          (click)="copyToClipboard(clientId, 'DEV_CLIENTS.SECRET_DIALOG.CLIENT_ID')"
          [nbTooltip]="'DEV_CLIENTS.SECRET_DIALOG.COPY' | translate"
        >
          <nb-icon icon="copy-outline"></nb-icon>
        </button>
      </div>
    </div>

    <div class="secret-row" style="margin-top: 15px">
      <label class="form-label">{{ 'DEV_CLIENTS.SECRET_DIALOG.CLIENT_SECRET' | translate }}</label>
      <div class="secret-box-wrapper">
        <code class="secret-box">{{ clientSecret }}</code>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary copy-btn"
          (click)="copyToClipboard(clientSecret, 'DEV_CLIENTS.SECRET_DIALOG.CLIENT_SECRET')"
          [nbTooltip]="'DEV_CLIENTS.SECRET_DIALOG.COPY' | translate"
        >
          <nb-icon icon="copy-outline"></nb-icon>
        </button>
      </div>
    </div>

    <div class="token-hint mt-3">
      <label class="form-label">{{ 'DEV_CLIENTS.SECRET_DIALOG.TOKEN_ENDPOINT' | translate }}</label>
      <div class="secret-box-wrapper">
        <code class="secret-box small">{{ tokenEndpoint }}</code>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary copy-btn"
          (click)="copyToClipboard(tokenEndpoint, 'DEV_CLIENTS.SECRET_DIALOG.TOKEN_ENDPOINT')"
        >
          <nb-icon icon="copy-outline"></nb-icon>
        </button>
      </div>
      <p class="text-muted small mb-0 mt-2">{{ 'DEV_CLIENTS.SECRET_DIALOG.TOKEN_HINT' | translate }}</p>
    </div>
  </nb-card-body>
  <nb-card-footer style="text-align: right">
    <button type="button" class="btn btn-primary px-4" (click)="close()">
      {{ 'DEV_CLIENTS.SECRET_DIALOG.ACK' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
